export const GET_DAILYDEMAND_REQUEST = "GET_DAILYDEMAND_REQUEST";
export const GET_DAILYDEMAND_SUCCESS = "GET_DAILYDEMAND_SUCCESS";
export const GET_DAILYDEMAND_FAILURE = "GET_DAILYDEMAND_FAILURE";

export const UPDATE_ACTUAL_QTY_REQUEST = "UPDATE_ACTUAL_QTY_REQUEST";
export const UPDATE_ACTUAL_QTY_SUCCESS = "UPDATE_ACTUAL_QTY_SUCCESS";
export const UPDATE_ACTUAL_QTY_FAILURE = "UPDATE_ACTUAL_QTY_FAILURE";

export const GET_BINS_FOR_PRINT_REQUEST = "GET_BINS_FOR_PRINT_REQUEST";
export const GET_BINS_FOR_PRINT_SUCCESS = "GET_BINS_FOR_PRINT_SUCCESS";
export const GET_BINS_FOR_PRINT_FAILURE = "GET_BINS_FOR_PRINT_FAILURE";

export const GET_MONTHLYDEMAND_REQUEST = "GET_MONTHLYDEMAND_REQUEST";
export const GET_MONTHLYDEMAND_SUCCESS = "GET_MONTHLYDEMAND_SUCCESS";
export const GET_MONTHLYDEMAND_FAILURE = "GET_MONTHLYDEMAND_FAILURE";

export const GET_MONTHLYDEMAND_DOWNLOAD_REQUEST = "GET_MONTHLYDEMAND_DOWNLOAD_REQUEST";
export const GET_MONTHLYDEMAND_DOWNLOAD_SUCCESS = "GET_MONTHLYDEMAND_DOWNLOAD_SUCCESS";
export const GET_MONTHLYDEMAND_DOWNLOAD_FAILURE = "GET_MONTHLYDEMAND_DOWNLOAD_FAILURE";

export const UPDATE_CNF_QTY_REQUEST = "UPDATE_CNF_QTY_REQUEST";
export const UPDATE_CNF_QTY_SUCCESS = "UPDATE_CNF_QTY_SUCCESS";
export const UPDATE_CNF_QTY_FAILURE = "UPDATE_CNF_QTY_FAILURE";

export const UPDATE_CNF_QTY_STATUS_BY_PLANNER_REQUEST =
  "UPDATE_CNF_QTY_STATUS_BY_PLANNER_REQUEST";
export const UPDATE_CNF_QTY_STATUS_BY_PLANNER_SUCCESS =
  "UPDATE_CNF_QTY_STATUS_BY_PLANNER_SUCCESS";
export const UPDATE_CNF_QTY_STATUS_BY_PLANNER_FAILURE =
  "UPDATE_CNF_QTY_STATUS_BY_PLANNER_FAILURE";

export const UPDATE_REMARK_REQUEST = "UPDATE_REMARK_REQUEST";
export const UPDATE_REMARK_SUCCESS = "UPDATE_REMARK_SUCCESS";
export const UPDATE_REMARK_FAILURE = "UPDATE_REMARK_FAILURE";

export const CREATEPICKUPLIST_REQUEST = "CREATEPICKUPLIST_REQUEST";
export const CREATEPICKUPLIST_SUCCESS = "CREATEPICKUPLIST_SUCCESS";
export const CREATEPICKUPLIST_FAILURE = "CREATEPICKUPLIST_FAILURE";

export const GET_PARTNO_FOR_PLANNER_REQUEST = "GET_PARTNO_FOR_PLANNER_REQUEST";
export const GET_PARTNO_FOR_PLANNER_SUCCESS = "GET_PARTNO_FOR_PLANNER_SUCCESS";
export const GET_PARTNO_FOR_PLANNER_FAILURE = "GET_PARTNO_FOR_PLANNER_FAILURE";

export const GET_PARTNO_REQUEST = "GET_PARTNO_REQUEST";
export const GET_PARTNO_SUCCESS = "GET_PARTNO_SUCCESS";
export const GET_PARTNO_FAILURE = "GET_PARTNO_FAILURE";

export const GET_PLANT_REQUEST = "GET_PLANT_REQUEST";
export const GET_PLANT_SUCCESS = "GET_PLANT_SUCCESS";
export const GET_PLANT_FAILURE = "GET_PLANT_FAILURE";

export const GET_VENDORS_REQUEST = "GET_VENDORS_REQUEST";
export const GET_VENDORS_SUCCESS = "GET_VENDORS_SUCCESS";
export const GET_VENDORS_FAILURE = "GET_VENDORS_FAILURE";

export const POST_CREATEASN_REQUEST = "POST_CREATEASN_REQUEST";
export const POST_CREATEASN_SUCCESS = "POST_CREATEASN_SUCCESS";
export const POST_CREATEASN_FAILURE = "POST_CREATEASN_FAILURE";

export const POST_CALCULATE_PACKAGE_DETAILS_REQUEST =
  "POST_CALCULATE_PACKAGE_DETAILS_REQUEST";
export const POST_CALCULATE_PACKAGE_DETAILS_SUCCESS =
  "POST_CALCULATE_PACKAGE_DETAILS_SUCCESS";
export const POST_CALCULATE_PACKAGE_DETAILS_FAILURE =
  "POST_CALCULATE_PACKAGE_DETAILS_FAILURE";

export const GET_CALCULATE_PACKAGE_WEIGHT_REQUEST =
  "GET_CALCULATE_PACKAGE_WEIGHT_REQUEST";
export const GET_CALCULATE_PACKAGE_WEIGHT_SUCCESS =
  "GET_CALCULATE_PACKAGE_WEIGHT_SUCCESS";
export const GET_CALCULATE_PACKAGE_WEIGHT_FAILURE =
  "GET_CALCULATE_PACKAGE_WEIGHT_FAILURE";

export const GET_PACKAGE_TYPE_REQUEST = "GET_PACKAGE_TYPE_REQUEST";
export const GET_PACKAGE_TYPE_SUCCESS = "GET_PACKAGE_TYPE_SUCCESS";
export const GET_PACKAGE_TYPE_FAILURE = "GET_PACKAGE_TYPE_FAILURE";

export const GET_DELIVERY_PLANT_REQUEST = "GET_DELIVERY_PLANT_REQUEST";
export const GET_DELIVERY_PLANT_SUCCESS = "GET_DELIVERY_PLANT_SUCCESS";
export const GET_DELIVERY_PLANT_FAILURE = "GET_DELIVERY_PLANT_FAILURE";

export const GET_UNLOADING_POINT_REQUEST = "GET_UNLOADING_POINT_REQUEST";
export const GET_UNLOADING_POINT_SUCCESS = "GET_UNLOADING_POINT_SUCCESS";
export const GET_UNLOADING_POINT_FAILURE = "GET_UNLOADING_POINT_FAILURE";

export const UPLOADCSV_FOR_DAILYDEMAND_REQUEST =
  "UPLOADCSV_FOR_DAILYDEMAND_REQUEST";
export const UPLOADCSV_FOR_DAILYDEMAND_SUCCESS =
  "UPLOADCSV_FOR_DAILYDEMAND_SUCCESS";
export const UPLOADCSV_FOR_DAILYDEMAND_FAILURE =
  "UPLOADCSV_FOR_DAILYDEMAND_FAILURE";

export const UPLOADCSV_FOR_MONTHLYDEMAND_REQUEST =
  "UPLOADCSV_FOR_MONTHLYDEMAND_REQUEST";
export const UPLOADCSV_FOR_MONTHLYDEMAND_SUCCESS =
  "UPLOADCSV_FOR_MONTHLYDEMAND_SUCCESS";
export const UPLOADCSV_FOR_MONTHLYDEMAND_FAILURE =
  "UPLOADCSV_FOR_MONTHLYDEMAND_FAILURE";

export const GET_UNCONFIRMED_MONTHLYDEMAND_REQUEST =
  "GET_UNCONFIRMED_MONTHLYDEMAND_REQUEST";
export const GET_UNCONFIRMED_MONTHLYDEMAND_SUCCESS =
  "GET_UNCONFIRMED_MONTHLYDEMAND_SUCCESS";
export const GET_UNCONFIRMED_MONTHLYDEMAND_FAILURE =
  "GET_UNCONFIRMED_MONTHLYDEMAND_FAILURE";

export const GET_VENDORS_WITH_PAGINATION_FAILURE =
  "GET_VENDORS_WITH_PAGINATION_FAILURE";
export const GET_VENDORS_WITH_PAGINATION_REQUEST =
  "GET_VENDORS_WITH_PAGINATION_REQUEST";
export const GET_VENDORS_WITH_PAGINATION_SUCCESS =
  "GET_VENDORS_WITH_PAGINATION_SUCCESS";

export const GET_DAILYDEMAND_DOWNLOAD_REQUEST =
  "GET_DAILYDEMAND_DOWNLOAD_REQUEST";
export const GET_DAILYDEMAND_DOWNLOAD_SUCCESS =
  "GET_DAILYDEMAND_DOWNLOAD_SUCCESS";
export const GET_DAILYDEMAND_DOWNLOAD_FAILURE =
  "GET_DAILYDEMAND_DOWNLOAD_FAILURE";
